require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-huis-in-de-bosjes.json") })
        }
      }, "path---projecten-huis-in-de-bosjes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-huis-in-de-bosjes!./.cache/json/projecten-huis-in-de-bosjes.json
// module id = 419
// module chunks = 231608221292675